/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// Custom web component for quantity badges selector
!function () {
  "use strict";

  /**
   * Quantity Selector Web Component
   * 
   * This component manages the selection of quantity badges and updates
   * the hidden quantity input field based on the selected badge's data-quantity attribute.
   */
  var QuantitySelector = /*#__PURE__*/function (_HTMLElement) {
    _inherits(QuantitySelector, _HTMLElement);
    var _super = _createSuper(QuantitySelector);
    function QuantitySelector() {
      var _this;
      _classCallCheck(this, QuantitySelector);
      _this = _super.call(this);
      _this.quantityInput = null;
      _this.badges = [];
      _this.selectedBadge = null;
      _this.calloutElement = null;
      _this.isUpdating = false; // Flag to prevent infinite loops
      return _this;
    }
    _createClass(QuantitySelector, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;
        // Find all quantity badges within this component
        this.badges = Array.from(this.querySelectorAll('.product__quantity-badge'));

        // Find the quantity input in the form
        var form = this.closest('.form__wrapper') || this.closest('form') || this.closest('.product-form');
        if (form) {
          this.quantityInput = form.querySelector('[name="quantity"]');
        }

        // Initialize event listeners for each badge
        this.badges.forEach(function (badge) {
          badge.addEventListener('click', _this2.onBadgeClick.bind(_this2));
        });

        // Set initial selection (first badge)
        if (this.badges.length > 0) {
          this.selectBadge(this.badges[0]);
        }
        this.checkAvailability();
        // Listen for theme variant change events
        document.addEventListener('theme:variant:change', function (event) {
          // Reset to first badge when variant changes
          _this2.checkAvailability();
        });
      }

      /**
       * Handle badge click event
       * @param {Event} event - The click event
       */
    }, {
      key: "onBadgeClick",
      value: function onBadgeClick(event) {
        var badge = event.currentTarget;
        this.selectBadge(badge);
      }
    }, {
      key: "checkAvailability",
      value: function checkAvailability() {
        var _this3 = this;
        setTimeout(function () {
          var selectedSellingPlan = document.querySelector('product-sticky select[name="selling_plan"]') || document.querySelector('[name="selling_plan"]');
          if (selectedSellingPlan && selectedSellingPlan.value) {
            if (_this3.quantityInput) {
              _this3.quantityInput.value = '1';
              // Don't call selectBadge here to avoid triggering pushState loop
              // Just update the visual state
              _this3.badges.forEach(function (b) {
                b.classList.remove('selected-quantity');
              });
              if (_this3.badges.length > 0) {
                _this3.badges[0].classList.add('selected-quantity');
                _this3.selectedBadge = _this3.badges[0];
              }
            }
            _this3.style.display = 'none';

            // Update product form state to reflect quantity change for subscription
            var productForm = document.querySelector('product-form') || document.querySelector('[data-product-form]');
            if (productForm && typeof productForm.updatePrice === 'function') {
              productForm.updatePrice();
            }
          } else {
            _this3.style.display = 'grid';
          }
        }, 100);
      }

      /**
       * Select a badge and update the quantity input
       * @param {Element} badge - The badge element to select
       */
    }, {
      key: "selectBadge",
      value: function selectBadge(badge) {
        var _this4 = this;
        // Prevent infinite loops
        if (this.isUpdating) return;
        this.isUpdating = true;

        // Remove selected class from all badges
        this.badges.forEach(function (b) {
          b.classList.remove('selected-quantity');
        });

        // Add selected class to the clicked badge
        badge.classList.add('selected-quantity');
        this.selectedBadge = badge;

        // Update quantity input value
        var quantity = badge.getAttribute('data-quantity');
        if (this.quantityInput && quantity) {
          this.quantityInput.value = quantity;

          // Dispatch change event to notify other components
          this.quantityInput.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }

        // Update prices based on selected quantity badge
        this.updatePrices();

        // Dispatch custom event for other components to listen to
        this.dispatchEvent(new CustomEvent('quantity:updated', {
          bubbles: true,
          detail: {
            quantity: quantity,
            badge: badge,
            percentageSaving: badge.getAttribute('data-percentage-saving')
          }
        }));

        // Trigger the product form to update prices including the Add to Cart button
        var productForm = document.querySelector('product-form') || document.querySelector('[data-product-form]');
        if (productForm) {
          // Try different methods to update the form
          if (typeof productForm.onVariantChange === 'function') {
            productForm.onVariantChange();
          } else if (typeof productForm.updatePrice === 'function') {
            productForm.updatePrice();
          }

          // Dispatch a custom event that the product form might listen to
          productForm.dispatchEvent(new CustomEvent('quantity:change', {
            bubbles: true,
            detail: {
              quantity: quantity
            }
          }));
        }

        // Reset the flag after a short delay
        setTimeout(function () {
          _this4.isUpdating = false;
        }, 200);
      }

      /**
       * Update all prices based on selected quantity badge
       */
    }, {
      key: "updatePrices",
      value: function updatePrices() {
        if (!this.selectedBadge) return;
        var discountedPrice = this.selectedBadge.getAttribute('data-product-price');
        var originalPrice = this.selectedBadge.getAttribute('data-total-price');
        var percentageSaving = parseFloat(this.selectedBadge.getAttribute('data-percentage-saving') || '0');

        // Update Add to Cart button prices
        this.updateATCButtonPrices(discountedPrice, originalPrice, percentageSaving);

        // Update product price block
        this.updateProductPriceBlock(discountedPrice, originalPrice, percentageSaving);
      }

      /**
       * Update Add to Cart button prices
       */
    }, {
      key: "updateATCButtonPrices",
      value: function updateATCButtonPrices(discountedPrice, originalPrice, percentageSaving) {
        // Find ATC button price elements
        var atcButton = document.querySelector('[data-add-to-cart-text]') || document.querySelector('[data-atc-button]');
        if (!atcButton) return;
        var priceElement = atcButton.querySelector('[data-product-price]');
        var comparePriceElement = atcButton.querySelector('[data-compare-price]');
        if (priceElement && discountedPrice) {
          priceElement.textContent = discountedPrice;
        }
        if (comparePriceElement) {
          if (percentageSaving > 0 && originalPrice) {
            // Show compare price when there's a discount
            comparePriceElement.textContent = originalPrice;
            comparePriceElement.classList.remove('hidden');
          } else {
            // Hide compare price when no discount
            comparePriceElement.classList.add('hidden');
          }
        }
      }

      /**
       * Update product price block in the form
       */
    }, {
      key: "updateProductPriceBlock",
      value: function updateProductPriceBlock(discountedPrice, originalPrice, percentageSaving) {
        var form = this.closest('.form__wrapper') || this.closest('form') || this.closest('.product-form');
        if (!form) return;

        // Find price block elements
        var priceWrapper = form.querySelector('[data-price-wrapper]') || form.querySelector('.product__price');
        if (!priceWrapper) return;
        var regularPrice = priceWrapper.querySelector('[data-product-price]') || priceWrapper.querySelector('.product__price--regular');
        var comparePrice = priceWrapper.querySelector('[data-compare-price]') || priceWrapper.querySelector('.product__price--compare');
        if (regularPrice && discountedPrice) {
          regularPrice.textContent = discountedPrice;
        }
        if (comparePrice) {
          if (percentageSaving > 0 && originalPrice) {
            comparePrice.textContent = originalPrice;
            comparePrice.classList.remove('hidden');
          } else {
            comparePrice.classList.add('hidden');
          }
        }
      }

      /**
       * Update subscription prices based on discount percentage
       * @param {string} percentageSaving - The discount percentage (e.g., "10", "15")
       * @deprecated Use updatePrices() instead
       */
    }, {
      key: "updateSubscriptionPrices",
      value: function updateSubscriptionPrices(percentageSaving) {
        var form = this.closest('.form__wrapper') || this.closest('form') || this.closest('.product-form');
        if (!form) return;

        // Get base price from the selected badge's data-product-price attribute
        var basePriceText = this.selectedBadge ? this.selectedBadge.getAttribute('data-product-price') : null;
        if (!basePriceText) return;

        // Extract numeric price value
        var basePriceValue = parseFloat(basePriceText.replace(/[^0-9.]/g, ''));
        if (isNaN(basePriceValue)) return;

        // Find one-time purchase price element
        var oneTimePurchaseGroup = form.querySelector('[data-one-time-purchase]') || form.querySelector('.product__price');
        if (!oneTimePurchaseGroup) return;
        var oneTimePurchasePrice = oneTimePurchaseGroup.querySelector('.product__price__amount') || oneTimePurchaseGroup.querySelector('.price');
        if (!oneTimePurchasePrice) return;

        // Update one-time purchase price with the pre-calculated and formatted price from data-product-price
        oneTimePurchasePrice.textContent = basePriceText;
      }

      /**
       * Get the current selected quantity
       * @returns {string} The selected quantity
       */
    }, {
      key: "selectedQuantity",
      get: function get() {
        return this.selectedBadge ? this.selectedBadge.getAttribute('data-quantity') : null;
      }
    }]);
    return QuantitySelector;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element if it's not already defined
  if (!customElements.get('data-quantity-selector')) {
    customElements.define('data-quantity-selector', QuantitySelector);
  }
}();

/**
 * Collection Top Filter Tabs Web Component
 * Compatible with existing collection-filters system
 */
var CollectionTopFilter = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(CollectionTopFilter, _HTMLElement2);
  var _super2 = _createSuper(CollectionTopFilter);
  function CollectionTopFilter() {
    var _this5;
    _classCallCheck(this, CollectionTopFilter);
    _this5 = _super2.call(this);
    _this5.sectionId = _this5.getAttribute('section-id');
    _this5.activeTags = new Set();
    _this5.collectionFilters = null;
    _this5.isUpdating = false;
    _this5.init();
    return _this5;
  }
  _createClass(CollectionTopFilter, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              try {
                // Find the main collection filters component
                this.collectionFilters = document.querySelector('collection-filters');
                this.initActiveStates();
                this.bindEvents();
              } catch (error) {
                console.warn('Error initializing CollectionTopFilter:', error);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "initActiveStates",
    value: function initActiveStates() {
      var _this6 = this;
      var url = new URL(window.location.href);
      var tagParams = url.searchParams.getAll("filter.p.tag");
      var allButton = this.querySelector('.top-filter-button[data-tag="all"]');

      // Clear all active states first
      this.querySelectorAll(".top-filter-button").forEach(function (btn) {
        return btn.classList.remove("is-active");
      });

      // Clear and rebuild active tags
      this.activeTags.clear();
      if (tagParams.length > 0) {
        // Set active tags and update buttons
        tagParams.forEach(function (tag) {
          _this6.activeTags.add(tag);
          var button = _this6.querySelector(".top-filter-button[data-tag=\"".concat(tag, "\"]"));
          if (button) {
            button.classList.add("is-active");
          }
        });
      } else if (allButton) {
        // No tags active, show "all" as active
        allButton.classList.add("is-active");
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this7 = this;
      this.querySelectorAll(".top-filter-button").forEach(function (button) {
        button.addEventListener("click", _this7.onFilterButtonClick.bind(_this7));
      });

      // Listen for collection filter updates to sync our state
      document.addEventListener('shopify:section:load', function () {
        setTimeout(function () {
          _this7.initActiveStates();
        }, 100);
      });

      // Listen for browser back/forward navigation
      window.addEventListener('popstate', function () {
        setTimeout(function () {
          _this7.initActiveStates();
        }, 100);
      });

      // Listen for collection filters updates if they exist
      if (this.collectionFilters) {
        // Override the collection filters renderSection to sync our state
        var originalRenderSection = this.collectionFilters.renderSection;
        if (originalRenderSection) {
          this.collectionFilters.renderSection = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            var result = originalRenderSection.apply(_this7.collectionFilters, args);
            setTimeout(function () {
              _this7.initActiveStates();
            }, 200);
            return result;
          };
        }
      }
    }
  }, {
    key: "onFilterButtonClick",
    value: function onFilterButtonClick(event) {
      var _this8 = this;
      event.preventDefault();
      if (this.isUpdating) return;
      var button = event.currentTarget;
      var tagHandle = button.dataset.tag;
      var isAll = tagHandle === "all";
      var allButton = this.querySelector('.top-filter-button[data-tag="all"]');
      var selectionMode = this.dataset.selectionMode || 'single';

      // Add loading state
      this.addLoadingState(button);
      if (isAll) {
        // Clear all tags and show all products
        this.activeTags.clear();
        this.querySelectorAll(".top-filter-button").forEach(function (btn) {
          return btn.classList.remove("is-active");
        });
        button.classList.add("is-active");
      } else {
        if (selectionMode === 'single') {
          // Single selection mode (radio button behavior)
          if (button.classList.contains("is-active")) {
            // If clicking an already active button, show all products
            this.activeTags.clear();
            this.querySelectorAll(".top-filter-button").forEach(function (btn) {
              return btn.classList.remove("is-active");
            });
            if (allButton) allButton.classList.add("is-active");
          } else {
            // Deactivate all other buttons and activate only this one
            this.activeTags.clear();
            this.querySelectorAll(".top-filter-button").forEach(function (btn) {
              return btn.classList.remove("is-active");
            });
            this.activeTags.add(tagHandle);
            button.classList.add("is-active");
          }
        } else {
          // Multi selection mode (checkbox behavior)
          if (button.classList.contains("is-active")) {
            this.activeTags["delete"](tagHandle);
            button.classList.remove("is-active");
          } else {
            this.activeTags.add(tagHandle);
            button.classList.add("is-active");
          }

          // Update "all" button state for multi-select
          if (this.activeTags.size === 0) {
            if (allButton) allButton.classList.add("is-active");
          } else if (allButton) {
            allButton.classList.remove("is-active");
          }
        }
      }

      // Apply the filter
      this.applyFilters()["finally"](function () {
        _this8.removeLoadingState(button);
      });
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      var _this9 = this;
      return new Promise(function (resolve, reject) {
        _this9.isUpdating = true;
        var url = _this9.buildFilterUrl();

        // Use the existing collection filters system if available
        if (_this9.collectionFilters && _this9.collectionFilters.renderSection) {
          try {
            var searchParams = url.searchParams.toString();
            _this9.collectionFilters.renderSection(searchParams, null, true);

            // Wait for the DOM to update and then handle ajaxinate
            setTimeout(function () {
              _this9.handleAjaxinateAfterFilter();
              _this9.isUpdating = false;
              resolve();
            }, 600);
          } catch (error) {
            console.warn('Error in collection filters renderSection:', error);
            _this9.isUpdating = false;
            // Fallback to page reload on error
            window.location.href = url.toString();
            resolve();
          }
        } else {
          // Fallback to manual page reload
          window.location.href = url.toString();
          resolve();
        }
      })["finally"](function () {
        console.log('auto close');
        // Auto-close filters on mobile after search completes
        _this9.autoCloseFiltersOnMobile(200);
        _this9.autoCloseFiltersOnMobile(400);
      });
    }
  }, {
    key: "handleAjaxinateAfterFilter",
    value: function handleAjaxinateAfterFilter() {
      // Find ajaxinate elements and reinitialize them safely
      try {
        var ajaxinateElements = document.querySelectorAll('ajaxinate-items');
        ajaxinateElements.forEach(function (element) {
          if (element && typeof element.reinit === 'function') {
            // Small delay to ensure DOM is ready
            setTimeout(function () {
              try {
                element.reinit();
              } catch (error) {
                console.warn('Error reinitializing ajaxinate element:', error);
              }
            }, 100);
          }
        });

        // Auto-close filters on mobile after search completes
        this.autoCloseFiltersOnMobile();
      } catch (error) {
        console.warn('Error handling ajaxinate after filter:', error);
      }
    }
  }, {
    key: "autoCloseFiltersOnMobile",
    value: function autoCloseFiltersOnMobile() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
      // Only trigger on mobile devices
      if (window.innerWidth <= 768) {
        // Find the filters toggle button and click it to close the filters
        var filtersToggle = document.querySelector('.collection__filters__toggle');
        if (filtersToggle) {
          // Add a small delay to ensure the DOM has updated
          setTimeout(function () {
            try {
              filtersToggle.click();
            } catch (error) {
              console.warn('Error clicking filters toggle:', error);
            }
          }, delay);
        }
      }
    }
  }, {
    key: "buildFilterUrl",
    value: function buildFilterUrl() {
      var url = new URL(window.location.origin + window.location.pathname);
      var currentParams = new URLSearchParams(window.location.search);

      // Preserve non-tag filter parameters
      var _iterator = _createForOfIteratorHelper(currentParams.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          if (!key.startsWith('filter.p.tag') && key !== 'page') {
            url.searchParams.append(key, value);
          }
        }

        // Add active tags
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.activeTags.forEach(function (tag) {
        url.searchParams.append("filter.p.tag", tag);
      });
      return url;
    }
  }, {
    key: "addLoadingState",
    value: function addLoadingState(button) {
      button.style.opacity = '0.6';
      button.style.pointerEvents = 'none';
      button.classList.add('loading');
    }
  }, {
    key: "removeLoadingState",
    value: function removeLoadingState(button) {
      button.style.opacity = '';
      button.style.pointerEvents = '';
      button.classList.remove('loading');
    }

    // Public method to refresh the component state
  }, {
    key: "refresh",
    value: function refresh() {
      try {
        // Re-find collection filters in case DOM changed
        this.collectionFilters = document.querySelector('collection-filters');
        this.initActiveStates();
      } catch (error) {
        console.warn('Error refreshing CollectionTopFilter:', error);
      }
    }
  }]);
  return CollectionTopFilter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define("collection-top-filter", CollectionTopFilter);

/**
 * Value Line Component
 * A custom web component for displaying value propositions on product pages
 * Listens to quantity badge selections and displays the corresponding value line text
 */
var ValueLine = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(ValueLine, _HTMLElement3);
  var _super3 = _createSuper(ValueLine);
  function ValueLine() {
    var _this10;
    _classCallCheck(this, ValueLine);
    _this10 = _super3.call(this);
    _this10.quantitySelector = null;
    return _this10;
  }
  _createClass(ValueLine, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // Find the quantity selector component
      this.quantitySelector = document.querySelector('data-quantity-selector');

      // Initial update
      this.updateValueLine();

      // Listen for quantity badge changes
      document.addEventListener('quantity:updated', this.handleQuantityUpdate.bind(this));
    }

    /**
     * Handle quantity badge selection changes
     * @param {CustomEvent} event - The quantity:updated event
     */
  }, {
    key: "handleQuantityUpdate",
    value: function handleQuantityUpdate(event) {
      if (event.detail && event.detail.badge) {
        var badge = event.detail.badge;
        this.updateFromBadge(badge);
      }
    }

    /**
     * Update value line content on initial load
     */
  }, {
    key: "updateValueLine",
    value: function updateValueLine() {
      if (!this.quantitySelector) {
        // No quantity selector found, hide the component
        this.style.display = 'none';
        return;
      }

      // Find the selected quantity badge
      var selectedBadge = this.quantitySelector.querySelector('.product__quantity-badge.selected-quantity');
      if (selectedBadge) {
        this.updateFromBadge(selectedBadge);
      } else {
        // No selected badge, hide the component
        this.style.display = 'none';
      }
    }

    /**
     * Update the value line content from a badge element
     * @param {HTMLElement} badge - The selected badge element
     */
  }, {
    key: "updateFromBadge",
    value: function updateFromBadge(badge) {
      var valueLineHtml = badge.getAttribute('data-value-line');
      if (valueLineHtml) {
        // Unescape HTML entities and set as innerHTML
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = valueLineHtml;
        this.innerHTML = tempDiv.innerHTML;
        this.style.display = '';
      } else {
        // No value line content, hide the component
        this.innerHTML = '';
        this.style.display = 'none';
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Remove event listener
      document.removeEventListener('quantity:updated', this.handleQuantityUpdate.bind(this));
    }
  }]);
  return ValueLine;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element if it's not already defined
if (!customElements.get('value-line')) {
  customElements.define('value-line', ValueLine);
}

/***/ }),

/***/ "./src/scss/main.scss":
/*!****************************!*\
  !*** ./src/scss/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/main": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main"], () => (__webpack_require__("./src/scss/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;